import { render, staticRenderFns } from "./backSidebar.vue?vue&type=template&id=3de19c46&scoped=true&"
import script from "./backSidebar.vue?vue&type=script&lang=js&"
export * from "./backSidebar.vue?vue&type=script&lang=js&"
import style0 from "./backSidebar.vue?vue&type=style&index=0&id=3de19c46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de19c46",
  null
  
)

export default component.exports